// ONE THING TO ACT ON, as a sentence: what it is, what it belongs to, when it was due, and
// the one button that moves it forward.
//
// A BIG AMOUNT APPEARS ONLY ON MONEY SOMEBODY OWES. A month to bill or a cost to charge on
// shows its figures small and muted, labelled as what they are — the contract's monthly
// rate, what the cost was — because printing them the same size as a debt is how a plan
// becomes a receivable in someone's head.
import he from '../../i18n/he';
import Money, { formatMoney } from '../../components/Money';
import DateText from '../../components/DateText';
import { useLookups } from '../../context/LookupsContext';
import ChargeAmounts from './ChargeAmounts';
import ChargeFiles from './ChargeFiles';
import RowActions from './RowActions';
import { chargeLabel } from './boardRows';

const t = he.collections.board;
const p = he.moneyScreen.item;

// client › retainer › job — whichever of them this thing has.
export function Path({ path }) {
  const parts = [path.client, path.retainer, path.job].filter(Boolean);
  return (
    <div className="mp-path">
      {parts.map((part, i) => (
        <span key={`${i}-${part}`}>{i > 0 && <span className="mp-path-sep" aria-hidden>‹</span>}{part}</span>
      ))}
    </div>
  );
}

export const PartlyPaid = ({ row }) => (Number(row.paid) > 0
  ? <span>{p.partlyPaid(formatMoney(row.paid), formatMoney(row.amount))}</span>
  : null);

function Title({ item }) {
  const lookups = useLookups();
  const { kind, row } = item;
  if (kind === 'bill_month') return <>{p.monthToBill} <DateText value={row.month} /></>;

  if (kind === 'charge') return <>{row.description || lookups.categoryLabel(row.category)}</>;
  return row.month
    ? <>{p.monthCharge} · <DateText value={row.month} /></>
    : <>{chargeLabel(row)} · <DateText value={row.issueDate} /></>;
}

function Meta({ item }) {
  const { kind, row, section } = item;
  if (kind === 'bill_month') {
    return row.expected != null
      ? <span>{t.monthly} {p.monthlyByContract}: <Money value={row.expected} /></span>
      : null;
  }

  if (kind === 'charge') {
    return (
      <>
        <ChargeAmounts row={row} />
        {row.convertsTopic && <span className="badge gray">{p.notBilling}</span>}
      </>
    );
  }

  return (
    <>
      <span>{section === 'late' ? p.lateSince : p.dueBy} <DateText value={row.dueDate} /></span>
      <PartlyPaid row={row} />
      {row.outOfTerm && <span className="badge gray">{t.outOfTerm}</span>}
    </>
  );
}

export default function ActionItem({ item, acts }) {
  const owes = item.kind === 'recorded';
  return (
    <article className={`mp-item mp-tone-${item.section}`}>
      <div className="mp-item-main">
        <Path path={item.path} />
        <div className="mp-item-title-row">
          <div className="mp-item-title"><Title item={item} /></div>
          {owes && <Money className="mp-amount" value={item.row.balance} />}
        </div>
        <div className="mp-item-meta">
          <Meta item={item} />
          {owes && (
            <ChargeFiles row={item.row} onChanged={acts.onFilesChanged} />
          )}
        </div>
      </div>
      <div className="mp-item-side">
        <RowActions kind={item.kind} card={item.card} row={item.row} month={item.month} acts={acts} />
      </div>
    </article>
  );
}
